// extracted by mini-css-extract-plugin
export var colorPatch = "Color-module--colorPatch--W0Kje";
export var input = "Color-module--input--sLqY3";